













































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapGetters } from "vuex";
import i18n from "@/i18n";

// Mixins
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import Context from "@/mixins/context";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import creditNotesFilters from "@/data/filters/creditNotes";
import creditNotesSorters from "@/data/sorters/creditNotes";
import { FilterOperators, FilterTypes, Sorters } from "@/data/table";
import { InvoiceCategoryCode } from "@/models/invoices";

// Types
import { ITableConfig, IFilter, ISorter } from "@/models/tables";
import { IClient } from "@/models/clients";
import { IContract, IContractProduct } from "@/models/contracts";

@Component({
  components: {
    "relative-invoice-status": () =>
      import("@/components/app/global/invoices/relativeInvoiceStatus.vue")
  },
  computed: {
    ...mapGetters({
      isMultibrand: "brand/isMultibrand"
    })
  }
})
export default class CreditNotesTable extends Mixins(
  FilteringSortingTableStore,
  Context
) {
  // Props
  @Prop({ required: false, default: null })
  public clientId!: IClient["id"];

  @Prop({ required: false, default: null })
  public contractId!: IContract["id"];

  @Prop({ required: false, default: null })
  public productId!: IContractProduct["id"];

  // Data
  public defaults: ITableConfig = {
    page: 1,
    limit: this.limit,
    sort: {
      field: "create_datetime",
      direction: Sorters.DESCENDING
    },
    filters: []
  };

  public isMultibrand!: boolean;

  public filters: IFilter[] = creditNotesFilters;

  public sorters: ISorter[] = creditNotesSorters;

  public loading = true;
  public filter = "";
  public dataModule: string = DataModules.INVOICES;

  public created() {
    const callWith = ["status"];
    if (this.isMultibrand) {
      callWith.push("brand");
    }
    if (this.isAdmin && !this.clientId) {
      callWith.push("client,client.image");
      this.filters.splice(
        5,
        0,
        {
          key: "client.firstname",
          label: i18n.t("_.client_firstname"),
          type: FilterTypes.STRING,
          operator: FilterOperators.EQUAL
        },
        {
          key: "client.lastname",
          label: i18n.t("_.client_lastname"),
          type: FilterTypes.STRING,
          operator: FilterOperators.EQUAL
        },
        {
          key: "client.email",
          label: i18n.t("_.client_email"),
          type: FilterTypes.STRING,
          operator: FilterOperators.EQUAL
        }
      );
    }
    if (callWith.length) {
      this.apiProps = {
        with: callWith.join(",")
      };
    }
    this.filter = this.$_.get(this.$route.params, "filter", "");
    this.getData();
  }

  public get allAvailableFilters() {
    return this.$_.cloneDeep(this.filters);
  }

  // Override mixin method
  public getStoreParams(params: any): Promise<any> {
    return this.$_.merge(params, {
      isClient: this.isClient,
      params: {
        ...this.categoryFilter,
        ...this.clientFilter,
        ...this.contractFilter,
        ...this.productFilter,
        ...this.stagedImportFilter
      }
    });
  }

  public get categoryFilter() {
    return {
      "filter[category.slug]": [
        InvoiceCategoryCode.CREDIT_NOTE,
        InvoiceCategoryCode.CREDIT_NOTE_FOR_REFUND
      ].join(",")
    };
  }

  public get clientFilter() {
    if (!this.clientId) return {};
    return { "filter[client_id]": this.clientId };
  }

  public get contractFilter() {
    if (!this.contractId) return {};
    return { "filter[contract_id]": this.contractId };
  }

  public get productFilter() {
    if (!this.productId) return {};
    return { "filter[products.contracts_product_id]": this.productId };
  }

  public get stagedImportFilter() {
    return this.clientId || this.contractId || this.productId
      ? { with_staged_imports: 1 }
      : {};
  }
}
